import axios from "axios";
import { actions as encryptedHotelActions } from "../modules/EncryptedHotel/_redux/encryptedHotelRedux";
import store from "../../redux/store";

export const getEncryptedHotelId = async (hotelId) => {
  try {
    const state = store.getState();
    const token = state.auth?.token;
    
    const baseURL = process.env.REACT_APP_SPRING_API_URL;
    const endpoint = 'common/get-encrypted-hotel-id';
    const url = `${baseURL}${endpoint}`;
    
    let authHeader = {};
    if (token) {
      authHeader = { 'Authorization': `Bearer ${token}` };
    } else {
      const specificToken = localStorage.getItem("token");
      authHeader = { 'Authorization': specificToken };
    }
    
    const response = await axios.get(url, {
      headers: {
        ...authHeader,
        'Content-Type': 'application/json',
      }
    });
    
    let encryptedHotelId;
    if (typeof response.data === 'object' && response.data.encryptedHotelID) {
      encryptedHotelId = response.data.encryptedHotelID;
    } else {
      encryptedHotelId = response.data;
    }
    
    store.dispatch(encryptedHotelActions.setEncryptedHotelId(encryptedHotelId));
    
    return encryptedHotelId;
  } catch (error) {
    console.error('Error fetching encrypted hotel ID:', error);
    throw error;
  }
};

export const getStoredEncryptedHotelId = () => {
  const state = store.getState();
  return state.encryptedHotel?.encryptedHotelId || null;
};

export const clearEncryptedHotelId = () => {
  store.dispatch(encryptedHotelActions.clearEncryptedHotelId());
};